import { useState } from 'react';
import { Header } from '../../ui/header/header';
import { SideBar } from '../../ui/sidebar/sidebar';
import { PageComponentDefaultProps } from '../../../models/page-component-default-props';
import { breadcrumbParts } from '../../../models/breadcrumb-parts';
import { BreadcrumbList } from '../../ui/breadcrumb-list/breadcrumb-list';
import { useAppSelector } from '../../../app/hooks';
import { CompanyUserEditor } from './company-user-editor';
import { CheckAllValid } from '../../../managers/validation/validation';
import { ValidationFactory } from '../../../managers/validation/validation-factory';
import { AppAuthModel } from '../../../models/authority/app-auth-model';

const ispBreadcrumbList = [
  breadcrumbParts.isp.home,
  breadcrumbParts.isp.companyList,
  breadcrumbParts.isp.companyDetail,
  breadcrumbParts.isp.companyUserList,
  breadcrumbParts.isp.companyUserEdit,
];

const companyBreadcrumbList = [
  breadcrumbParts.company.home,
  breadcrumbParts.company.userList,
  breadcrumbParts.company.userEdit,
];

type Props = {
  companyCode?: string,
  memberId: string,
} & PageComponentDefaultProps;

// バリデーション用意
const validations = {
  require: ValidationFactory('requireEdit'),
  length30: ValidationFactory('length30'),
  length80: ValidationFactory('length80'),
  length256: ValidationFactory('length256'),
  kana: ValidationFactory('kana'),
};

export const CompanyEditUser = (props: Props) => {
  const { apiManger, companyCode, memberId } = props;

  const [breadcrumbList, setBreadcrumbList] = useState(
    apiManger.type === 'isp' ?
      ispBreadcrumbList :
      companyBreadcrumbList,
  );
  // -------------------- state --------------------
  const [resolveFlag, setResolveFlag] = useState(false);
  const { breadcrumbName } = useAppSelector((state) => state.company);
  const [isDisabled, setIsDisabled] = useState(CheckAllValid(validations));
  // 有効 (未退職者)
  const [valid, setValid] = useState(true);
  const [authModel, setAuthModel] = useState<AppAuthModel>(new AppAuthModel());

  return (
    <div
      id="App"
      className="company edit"
    >
      <SideBar
        currentPage="company-list"
        apiManger={apiManger.type}
      />
      <div className="main_cnt">
        <Header apiManger={apiManger.type} />
        <div className="inner">
          {breadcrumbName || resolveFlag ?
            <BreadcrumbList breadcrumbList={breadcrumbList} /> :
            <></>}
          <section>
            <header>
              <h2>ユーザー情報編集</h2>
            </header>
            <CompanyUserEditor
              companyCode={companyCode}
              memberId={memberId}
              apiManger={apiManger}
              setBreadcrumbList={setBreadcrumbList}
              companyBreadcrumbList={companyBreadcrumbList}
              setResolveFlag={setResolveFlag}
              isDialog={false}
              isDisabled={isDisabled}
              setIsDisabled={setIsDisabled}
              valid={valid}
              setValid={setValid}
              authModel={authModel}
              setAuthModel={setAuthModel}
            />
          </section>
        </div>
      </div>
    </div>
  );
};
